"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.library.empty': 'Nessun post',
    'socialMediaPlan.library.emptyDesc': 'Crea il tuo primo post.',
    'socialMediaPlan.library.contains_errors': 'Questo post contiene errori di pubblicazione',
};
